<ng-template [ngIf]="isCambiandoPreventivo">
  <app-loading></app-loading>
</ng-template>
   <div class="d-flex mt-2">
      <form [formGroup]="cambiaPreventivoForm">
        <div class="grid formgrid p-fluid">
        <div class="field col-6">
          <label for="preventivoAttuale" class="font-small text-900 text-blue-900">Preventivo attuale</label>
          <span class="p-input-icon-left">
            <i class="pi pi-euro"></i>
            <p-inputNumber mode="currency" inputId="preventivo" currency="EUR" locale="it-IT" formControlName="preventivo" [styleClass]="'right-align'"> </p-inputNumber>

          </span>
        </div>
    
        <!-- Campo per il nuovo valore del preventivo -->
        <div class="field col-6">
          <label for="nuovoPreventivo" class="font-small text-900 text-blue-900">Nuovo preventivo</label>
          <span class="p-input-icon-left">
            <i class="pi pi-euro"></i>
            <p-inputNumber mode="currency" inputId="nuovoPreventivo" currency="EUR" locale="it-IT" formControlName="nuovoPreventivo" [styleClass]="'right-align'"> </p-inputNumber>
          </span>
        </div>
      </div> 
      <div class="field mt-2 mb-2 col-12">
          <p-fileUpload 
                mode="basic" 
                name="caricaFilePreventivo"
                multiple="false"
                maxFileSize="5000000000"
                accept=".pdf"
                [auto]="false"
                chooseLabel="{{label}}"
                chooseIcon="{{icona}}"
                uploadIcon="{{icona}}"
                uploadLabel="{{label}}"
                [styleClass]="filePreventivoClass"
                (onUpload)="onPreventivoFileUpload($event)" 
                (onSelect)="onPreventivoFileSelect($event)" 
                url="https://www.primefaces.org/cdn/api/upload.php"
            >
          </p-fileUpload>
      </div>
      </form>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
      <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
      styleClass="p-button-warning"></p-button>
     <p-button  icon="pi pi-check" label="Conferma"
      class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isCambiandoPreventivo || !cambiaPreventivoForm.valid"></p-button>
  </div>
    <p-toast />
    <p-confirmDialog /> 